import { render, staticRenderFns } from "./HRParametersTab.vue?vue&type=template&id=174436d4&"
import script from "./HRParametersTab.vue?vue&type=script&lang=js&"
export * from "./HRParametersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports